<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="value" width="500" light>
    <template v-slot:activator="activator">
      <slot name="dactivator" v-bind:dactivator="activator"> </slot>
    </template>
    <v-card >
      <v-card-title class="headline dark lighten-2 pa-4" warning-title :style="titleStyle">
        <slot name="title">
          {{ title }}
        </slot>
      </v-card-title>
      <v-card-text class="px-5 py-3">
        <slot name="content">
          {{ content }}
        </slot>
      </v-card-text>
      <v-divider ></v-divider>
      <v-card-actions class="pa-3">
        <slot name="actions">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primaryLight4"
            outline
            @click="$emit('secondaryActionClick')"
            v-if="secondaryActionText"
            :loading="secondaryActionLoading"
          >
            {{ secondaryActionText }}
          </v-btn>
          <v-btn
            color="warning"
            :loading="primaryActionLoading"
            depressed
            dark
            @click="$emit('primaryActionClick')"
          >
            {{ primaryActionText }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LgDialog',
  props: {
    value: Boolean,
    title: String,
    content: String,
    titleBg: {
      type: String,
      default: () => '#fff'
    },
    primaryActionText: {
      type: String,
      default: () => 'Yes'
    },
    secondaryActionText: {
      type: String
    },
    primaryActionLoading: Boolean,
    secondaryActionLoading: Boolean
  },
  data: function() {
    return {}
  },
  computed: {
    titleStyle() {
      const style = {'background': this.titleBg}
      if(this.titleBg !== '#fff'){
        style.color = "#fff"
      }
      return style
    }
  },
  methods: {}
}
</script>

<style scoped></style>
